export enum PlayerEvent {
  ERROR = 'ERROR',
  PLAYBACK_END = 'PLAYBACK_END',
  NO_MORE_SEGMENTS = 'NO_MORE_SEGMENTS',
  TS_UPDATE = 'TIME_UPDATE',
  SEEKING_START = 'SEEKING_START',
  SEEKING_END = 'SEEKING_END',
  PLAYING = 'PLAYING',
  PAUSED = 'PAUSED',
}
